import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";


@Component({
    selector: 'cm-contract-notification-type-object',
    templateUrl: './cm-contract-notification-type-object.component.html',
    standalone: false
})
export class CmContractNotificationTypeObjectComponent
    extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    widgetBasic: WidgetData;
    widgetRestrictContractType: WidgetData;
    widgetRestrictGroup: WidgetData;


    /**
     * On Object Change.
     */
    onObjectChanged() {
        // create filter
        const filterCriteria = FilterCriteria.create("contractNotificationType", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);

        this.widgetBasic = WidgetFactory.createWidgetEntityData(
            "cm.contract.notification.type.basic",
            "Benachrichtigungstyp",
            "cm.ContractNotificationType",
            this.objectIdentifier.objectId
        );

        this.widgetRestrictContractType = WidgetFactory.createWidgetList(
            "cm.contract.notification.type.restrictType",
            "Vertragstypen",
            "table",
            "list",
            "entity",
            "cm.ContractNotificationTypeRestrictContractType",
            "Keine Enschränkung vorhanden",
            ObjectRequestList.createBasic(true, [filterCriteria], [])
        );

        this.widgetRestrictGroup = WidgetFactory.createWidgetList(
            "cm.contract.notification.type.restrictGroup",
            "Gruppen",
            "table",
            "list",
            "entity",
            "cm.ContractNotificationTypeRestrictGroup",
            "Keine Enschränkung vorhanden",
            ObjectRequestList.createBasic(true, [filterCriteria], [])
        );

    }

}
